import { Step } from 'src/app/components/Pages/GetStarted/StepLayout/Step';
import { getUrlPathWithPreservedQuery } from 'src/app/utils';

import { ButtonContainer, StyledSingleButton } from '../styles';

export const WaitlistConfirmation = () => {
  const redirectHome = () => (window.location.href = getUrlPathWithPreservedQuery('/'));
  return (
    <Step
      title="You’re all set"
      text="You’ll be the first to know when we arrive in your neighborhood. We can’t wait to look after you."
      hideHeader
    >
      <ButtonContainer>
        <StyledSingleButton size="medium" onClick={redirectHome} style={'capsuleBlue50'}>
          Done
        </StyledSingleButton>
      </ButtonContainer>
    </Step>
  );
};
